import React from 'react';
import { useTranslation } from 'react-i18next';

const HeroMinimal = () => {
  const { t } = useTranslation();
  
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="bg-black">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-32 lg:py-48">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="max-w-4xl">
            {/* Main Headline */}
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-tight mb-6 text-primary">
              {t('hero.title')}{' '}
              <span className="font-serif-italic text-gold">
                {t('hero.titleHighlight')}
              </span>
              {' '}{t('hero.titleEnd')}
            </h1>

            {/* Subheading */}
            <p className="text-lg md:text-xl text-secondary font-sans leading-relaxed mb-12 max-w-2xl">
              {t('hero.subtitle')}
            </p>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={() => scrollToSection('#work')}
                className="inline-flex items-center justify-center px-8 py-4 bg-gold text-black rounded-full font-sans font-medium hover:opacity-90 transition-opacity"
              >
                {t('hero.cta1')}
              </button>
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('#contact');
                }}
                className="inline-flex items-center justify-center px-8 py-4 text-gold font-sans font-medium underline underline-offset-4 hover:opacity-60 transition-opacity"
              >
                {t('hero.cta2')}
              </a>
            </div>
          </div>

          {/* Professional Headshot */}
          <div className="hidden lg:block">
            <div className="relative">
              <img
                src="/images/portfolio/aryan-portrait.jpg"
                alt="Aryan Shivhare - Professional LinkedIn Photo"
                className="w-full max-w-md mx-auto rounded-lg shadow-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroMinimal;
